<div class="multiselect-header">
  <ng-container #headerContainer></ng-container>
  <div class="title-wrapper" *ngIf="isTemplateEmpty">
    <span class="title-place">{{ title ? title : ("multiselectHeader.defaultTitle" | translate) }}</span>
  </div>
</div>
<ng-template #multiselectHeaderContainer></ng-template>
